import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Container, Paper, Grid, Typography, Button } from "@mui/material";
import { getUserData, getCurrentUser } from "../../services/userServices";
import FormHeader from "../Form/FormHeader";
import TwoFactorSettings from "./TwoFactorSettings";

const UserShow = () => {
  const [user, setUser] = useState([]);
  const [roles, setRoles] = useState([]);
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const location = useLocation();

  const handleGetUserData = async (id) => {
    try {
      const data = await getUserData(id);
      setUser(data.user || {});
      setRoles(data.roles || []);

    } catch (err) {
      setUser({});
      setRoles([]);
    }
  };

  const getProfileData = async () => {
    try {
      const data = await getCurrentUser();
      setUser(data.user || {});
      setRoles(data.roles || []);

    } catch (err) {
      setUser({});
      setRoles([]);
    }
  };

  useEffect(() => {
    if (id) {
      setTitle("Datos del usuario");
      handleGetUserData(id);
    } else {
      setTitle("Mi perfil");
      getProfileData();
    }
  }, [location.key]);

  return (
    <Container sx={{ padding: 5 }}>
      <FormHeader title={title} />
      <TwoFactorSettings user={user} onStatusChange={setUser} />
      <Paper elevation={2} sx={{ padding: 5 }}>
        <Grid container direction="row">
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Nombre:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {user?.name}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Apellido:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {user?.last_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Correo:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {user?.email}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Teléfono:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {user?.phone}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Nombre de usuario:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {user?.username}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="row">
              <Typography variant="subtitle2" gutterBottom>
                Rol:
              </Typography>

              <Typography variant="body2" gutterBottom>
                {roles?.length > 0 ? roles.join(", ") : "Sin rol asignado"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default UserShow;
